var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m481.101562 512h-450.203124c-17.066407 0-30.898438-13.832031-30.898438-30.898438v-392.824218h512v392.824218c0 17.066407-13.832031 30.898438-30.898438 30.898438zm0 0",
    fill: "#dd352e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 105.929688h-512v-75.03125c0-17.066407 13.832031-30.898438 30.898438-30.898438h450.203124c17.066407 0 30.898438 13.832031 30.898438 30.898438zm0 0",
    fill: "#28384c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.308594 35.308594h35.3125v35.3125h-35.3125zm0 0",
    fill: "#dd352e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.929688 35.308594h35.3125v35.3125h-35.3125zm0 0",
    fill: "#ebba16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.550781 35.308594h35.3125v35.3125h-35.3125zm0 0",
    fill: "#23a24d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m167.722656 326.621094h-114.757812c-3.160156 0-6.082032-1.6875-7.652344-4.433594-1.570312-2.742188-1.5625-6.105469.027344-8.84375l61.792968-105.929688c2.453126-4.203124 7.863282-5.625 12.074219-3.179687 4.210938 2.453125 5.632813 7.867187 3.179688 12.078125l-54.050781 92.652344h99.386718c4.875 0 8.828125 3.957031 8.828125 8.828125 0 4.871093-3.953125 8.828125-8.828125 8.828125zm0 0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m123.585938 379.585938c-4.871094 0-8.828126-3.953126-8.828126-8.828126v-105.929687c0-4.875 3.957032-8.828125 8.828126-8.828125 4.875 0 8.828124 3.953125 8.828124 8.828125v105.929687c0 4.875-3.953124 8.828126-8.828124 8.828126zm0 0",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m450.207031 326.621094h-114.757812c-3.160157 0-6.082031-1.6875-7.65625-4.433594-1.570313-2.742188-1.5625-6.105469.027343-8.84375l61.792969-105.929688c2.457031-4.203124 7.867188-5.625 12.078125-3.179687 4.210938 2.453125 5.632813 7.867187 3.175782 12.078125l-54.050782 92.652344h99.390625c4.871094 0 8.828125 3.957031 8.828125 8.828125 0 4.871093-3.957031 8.828125-8.828125 8.828125zm0 0",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m406.070312 379.585938c-4.875 0-8.828124-3.953126-8.828124-8.828126v-105.929687c0-4.875 3.953124-8.828125 8.828124-8.828125 4.871094 0 8.828126 3.953125 8.828126 8.828125v105.929687c0 4.875-3.957032 8.828126-8.828126 8.828126zm0 0",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m251.585938 379.585938c-31.636719 0-57.378907-25.742188-57.378907-57.378907v-61.792969c0-31.636718 25.742188-57.378906 57.378907-57.378906 31.636718 0 57.378906 25.742188 57.378906 57.378906v61.792969c0 31.636719-25.742188 57.378907-57.378906 57.378907zm0-158.894532c-21.902344 0-39.722657 17.820313-39.722657 39.722656v61.792969c0 21.902344 17.820313 39.722657 39.722657 39.722657 21.902343 0 39.722656-17.820313 39.722656-39.722657v-61.792969c0-21.902343-17.820313-39.722656-39.722656-39.722656zm0 0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a667b5ebfd8c27995c1d39f2056cca21.svg";
export { ForwardRef as ReactComponent };